import PropTypes from 'prop-types';
import { Disclosure } from '@headlessui/react';
import { MinusSmallIcon, PlusSmallIcon } from '@heroicons/react/24/outline';
import React from 'react';

export default function Faqs({ data }) {
  if (data && data.length === 0) {
    return null;
  }

  return (
    <div id="faqs" className="bg-white">
      <div className="px-6 pt-0 pb-24 mx-auto max-w-7xl sm:pb-32 lg:px-8 lg:pb-40">
        <div className="max-w-4xl mx-auto divide-y divide-gray-900/10">
          <h2 className="mb-8 text-2xl md:text-4xl payfair">Preguntas frecuentes</h2>
          <dl className="mt-10 space-y-6 divide-y divide-gray-900/10">
            {data.map((faq) => (
              <Disclosure as="div" key={faq.question} className="pt-6">
                {({ open }) => (
                  <>
                    <dt>
                      <Disclosure.Button className="flex items-start justify-between w-full text-left text-gray-900">
                        <span className="text-base font-semibold leading-7">{faq.question}</span>
                        <span className="flex items-center ml-6 h-7">
                          {open ? (
                            <MinusSmallIcon className="w-6 h-6" aria-hidden="true" />
                          ) : (
                            <PlusSmallIcon className="w-6 h-6" aria-hidden="true" />
                          )}
                        </span>
                      </Disclosure.Button>
                    </dt>
                    <Disclosure.Panel as="dd" className="pr-12 mt-2">
                      <p className="text-base leading-7 text-gray-600">{faq.answer}</p>
                    </Disclosure.Panel>
                  </>
                )}
              </Disclosure>
            ))}
          </dl>
        </div>
      </div>
    </div>
  );
}

Faqs.propTypes = {
  data: PropTypes.array,
};
